import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {BelegValidateDTO} from '../../interfaces/beleg-validate-dto.interface';


export const fakturierungsbelegEntitiesAdapter: EntityAdapter<BelegValidateDTO> = createEntityAdapter<BelegValidateDTO>();
